var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'has-background-black-ter': this.$root.$children[0].darkTheme},attrs:{"id":"app"}},[_c('Background'),_c('Home')],1)}
var staticRenderFns = []

export { render, staticRenderFns }